import loadSpecificCharacteristicAdjTopReasons from './loadSpecificCharacteristicAdjTopReasons'
import createAdjDetailHarness from './createAdjDetailHarness'
//----------------------------------
// load characteristic adjs harness
//----------------------------------
export default function loadCharacteristicAdjsHarness(character) {
  console.log('-------------------------------------')
  console.log('IN loadCharacteristicAdjsHarness')
  //==============================================================================
  // A. loop characteristics
  //-------------------------
  character.characteristics.forEach((a) => {
    console.log('A. processing characteristic = ', a)
    //--------------------------
    // loop characteristic adjs
    //--------------------------
    a.characteristic_adjs.forEach((b) => {
      console.log('A.1 processing characteristic adj = ', b)
      //----------------------------------------------
      // load specific characteristic adj top reasons
      //----------------------------------------------
      character = loadSpecificCharacteristicAdjTopReasons({
        adj: b,
        source: 'character_direct',
        character,
      })
      //-------------------------
      // create adj detail entry
      //-------------------------
      const adj_entry = createAdjDetailHarness({
        adj: b,
        adjs: character.characteristic_adjs,
        source: 'character_direct',
        character,
      })
      //-----------------
      // check adj entry
      //-----------------
      if (adj_entry) {
        //---------------
        // add adj entry
        //---------------
        character.characteristic_adjs.push(adj_entry)
        console.log('A. +++++++++ CREATED CHARACTERISTIC ADJ ENTRY = ', adj_entry)
      } else {
        console.error(
          'A. loadCharacteristicAdjsHarness: failed to create characteristic adj entry for adj = ',
          b,
        )
      }
    })
    //----------------------------------------------------------
    // add any rune characteristic adjs for this characteristic
    //----------------------------------------------------------
    if (a.integrated_rune_characteristic_adjs && a.integrated_rune_characteristic_adjs.length > 0) {
      //==============================================================================
      // B. loop rune characteristic adjs
      //----------------------------------
      a.integrated_rune_characteristic_adjs.forEach((c) => {
        //----------------------------------------------
        // load specific characteristic adj top reasons
        //----------------------------------------------
        character = loadSpecificCharacteristicAdjTopReasons({
          adj: c,
          source: 'integrated_rune',
          character,
        })
        //-------------------------
        // create adj detail entry
        //-------------------------
        const adj_entry = createAdjDetailHarness({
          adj: c,
          adjs: character.characteristic_adjs,
          source: 'integrated_rune',
          character,
        })
        //-----------------
        // check adj entry
        //-----------------
        if (adj_entry) {
          //---------------
          // add adj entry
          //---------------
          character.characteristic_adjs.push(adj_entry)
          console.log('B. +++++++++ CREATED CHARACTERISTIC ADJ ENTRY = ', adj_entry)
        } else {
          console.error(
            'B. loadCharacteristicAdjsHarness: failed to create characteristic adj entry for adj = ',
            c,
          )
        }
      })
    }
  })
  return character
}
